module.exports = __webpack_public_path__ + "490dcf864004b6a75c8f63294b52b3b8.svg";